<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="600px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
        <el-form-item label="讲师等级名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入讲师等级名称" />
        </el-form-item>
        <el-form-item label="描述：">
          <el-input v-model="form.described" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="状态：" prop="isEnable">
          <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch> {{form.isEnable?'启用':'禁用'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import lecturerLevelApi from '@/api/course/lecturerLevel'
function initFormBean() {
  const formBean = {
    id: null,
    name: null,
    described: null,
    isEnable: false,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        name: [{ required: true, message: '请输入讲师等级名称', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            lecturerLevelApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            lecturerLevelApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
